import dxDrawer from "devextreme/ui/drawer";
import dxLoadPanel from "devextreme/ui/load_panel";
import dxToolbar from "devextreme/ui/toolbar";
import dxTreeView from "devextreme/ui/tree_view";
import LogoRaster from "../img/logo_raster.png";
import selecionaEmpresa from "../login/selecionaEmpresa";
import HermesNotifier from "../notificacoes/HermesNotifier";
import { getAllowedMenus, logout } from "../services/auth/api";
import { handleError } from "../telas/jornada/Utils";
import ControleSessao from "./ControleSessao";
import ControleTabPadrao from "./ControleTabPadrao";

export default class MenuNavegacao {
    /**
     *
     * @param {string} empresaLogado
     * @param {string} filiaisLogado
     */
    constructor(empresaLogado, filiaisLogado) {
        this.empresaLogado = empresaLogado;
        this.filiaisLogado = filiaisLogado;
        this.siglaUsuario = "";

        const nomeCompletoUsuario = ControleSessao.getNomeUsuario().split(" ");
        const primeiraLetraNome = nomeCompletoUsuario[0].charAt(0);
        let primeiraLetraSobrenome = nomeCompletoUsuario[0].charAt(1);
        if (nomeCompletoUsuario[1]) {
            primeiraLetraSobrenome =
                nomeCompletoUsuario[0].charAt(0) === "C" &&
                nomeCompletoUsuario[1].charAt(0) === "U"
                    ? nomeCompletoUsuario[0].charAt(1)
                    : nomeCompletoUsuario[1].charAt(0);
        }
        this.siglaUsuario = primeiraLetraNome + primeiraLetraSobrenome;

        // Adiciona nome da empresa logada
        this.filiaisLogado.unshift({
            disabled: true,
            CAB_CODIGO: -1,
            CAB_RAZAO: this.empresaLogado,
        });

        // Adiciona opção de trocar empresa
        this.filiaisLogado.unshift({
            CAB_CODIGO: 0,
            CAB_RAZAO: "Trocar de Empresa/Filial",
        });
    }

    render() {
        this.renderDrawer = this.drawer();
        this.renderToolbar = this.toolbar(this.logout);

        this.renderControleTabPadrao = new ControleTabPadrao(
            this.renderDrawer.instance,
        );
        this.renderControleTabPadrao.render();

        this.autoHeight();
    }

    drawer() {
        let alturaMenuLateral = window.innerHeight - 46;
        if (window.innerWidth <= 450) {
            alturaMenuLateral = window.innerHeight - 92;
        }

        const content = "#drawer";
        const instance = new dxDrawer(content, {
            opened: true,
            closeOnOutsideClick: true,
            template: () => {
                const content = $("<div style='padding: 5px'>");
                const instanceTreeView = new dxTreeView(content, {
                    dataSource: [],
                    //dataSource: menuNavegacao,
                    expandEvent: "click",
                    searchEnabled: true,
                    searchExpr: "text",
                    dataStructure: "plain",
                    parentIdExpr: "categoria",
                    keyExpr: "ID",
                    hoverStateEnabled: true,
                    focusStateEnabled: true,
                    activeStateEnabled: false,
                    width: 200,
                    height: alturaMenuLateral,
                    onItemClick: ({ event, itemData }) => {
                        try {
                            if (!itemData) return;

                            if (!itemData.classInvoke)
                                return console.warn(
                                    `Classe não informada para a tela ${itemData.text}`,
                                );

                            this.renderControleTabPadrao.incluiTab(
                                itemData.text,
                                itemData.classInvoke,
                            );
                        } catch (e) {
                            console.log(e);
                        }
                    },
                });

                this.instanceTreeView = instanceTreeView;

                getAllowedMenus()
                    .then((allowedMenus) => {
                        instanceTreeView.option(
                            "dataSource",
                            this.generateArrayMenu(allowedMenus),
                        );
                    })
                    .catch((error) => handleError(error));

                return content;
            },
        });

        return {
            content,
            instance,
        };
    }

    toolbar(logout) {
        if (window.innerWidth > 450) {
            $(".raster-app").prepend($("<div id='toolbar'></div>"));
            const content = $("#toolbar");
            this.toolbarDesktop(content, logout);
        } else {
            $(".raster-app").prepend($("<div id='toolbar-buttons'></div>"));
            $(".raster-app").prepend($("<div id='toolbar-logo'></div>"));

            const contentLogo = $("#toolbar-logo");
            this.toolbarLogoMobile(contentLogo);
            const contentButtons = $("#toolbar-buttons");
            this.toolbarButtonsMobile(contentButtons, logout);
        }
    }

    toolbarDesktop(content, logout) {
        return new dxToolbar(content, {
            items: [
                {
                    location: "before",
                    template: function () {
                        const logoElement = $(
                            '<div class="toolbar-desktop-logo" />',
                        );
                        return $(
                            '<div style="display: flex; justify-content: center; height: 38px; width: 180px;" />',
                        ).append(logoElement);
                    },
                },
                {
                    widget: "dxButton",
                    location: "before",
                    options: {
                        stylingMode: "text",
                        icon: "menu",
                        text: "Menu",
                        elementAttr: { class: "text-white" },
                        onClick: () => {
                            this.renderDrawer.instance.toggle();
                        },
                    },
                },
                {
                    location: "after",
                    widget: "dxButton",
                    options: {
                        stylingMode: "text",
                        icon: "tips",
                        text: "Novidades",
                        elementAttr: { class: "text-white" },
                        onClick: () => {
                            window
                                .open(process.env.LOGAE_RELEASES_URL, "_blank")
                                .focus();
                        },
                    },
                },
                {
                    location: "after",
                    widget: "dxSelectBox",
                    options: {
                        stylingMode: "text",
                        items: this.filiaisLogado,
                        displayExpr: "CAB_RAZAO",
                        keyExpr: "CAB_CODIGO",
                        width: 250,
                        value: this.filiaisLogado[1],
                        onValueChanged: (args) => {
                            if (args.value.CAB_CODIGO == 0) {
                                // Remove HTML para voltar ao estado inicial
                                $(".raster-app").empty();
                                setTimeout(() => {
                                    // Precisa de um tempinho pro JQuery conseguir remover tudo
                                    new selecionaEmpresa();
                                }, 10);
                            }
                        },
                    },
                },
                {
                    location: "after",
                    template: (data, index, element) => {
                        new HermesNotifier(element);
                    },
                },
                {
                    widget: "dxDropDownButton",
                    location: "after",
                    options: {
                        text: this.siglaUsuario,
                        elementAttr: { class: "menu-usuario" },
                        dropDownOptions: {
                            width: 230,
                        },
                        onItemClick: function (e) {
                            switch (e.itemData.name) {
                                case "Sair":
                                    new dxLoadPanel($(".loadpanel"), {
                                        shadingColor: "rgba(0,0,0,0.4)",
                                        position: {
                                            my: "center",
                                            at: "center",
                                        },
                                        showIndicator: true,
                                        showPane: true,
                                        shading: true,
                                        closeOnOutsideClick: false,
                                        message: "Desconectado...",
                                        visible: true,
                                    });

                                    logout();
                                    break;
                            }
                        },
                        displayExpr: "name",
                        keyExpr: "id",
                        items: [
                            {
                                name: `Olá, ${ControleSessao.getNomeUsuario()}`,
                                disabled: true,
                                template: () => {
                                    return $(
                                        `<div style='padding-bottom: 10px; border-bottom: 1px dashed #020039;'>Olá, ${ControleSessao.getNomeUsuario()}</div>`,
                                    );
                                },
                            },
                            {
                                name: "Sair",
                                icon: "fas fa-sign-out-alt",
                            },
                        ],
                    },
                },
            ],
        });
    }

    toolbarLogoMobile(content) {
        return new dxToolbar(content, {
            width: "100%",
            items: [
                {
                    template: function (e) {
                        return $(
                            '<div style="display: flex; justify-content: center; height: 38px; width: 100%; margin: 0 20px;" />',
                        ).append(
                            $("<img />")
                                .attr({ src: LogoRaster })
                                .addClass("img-fluid"),
                        );
                    },
                },
            ],
        });
    }

    toolbarButtonsMobile(content, logout) {
        return new dxToolbar(content, {
            width: "100%",
            items: [
                {
                    widget: "dxButton",
                    options: {
                        stylingMode: "text",
                        icon: "menu",
                        onClick: () => {
                            this.renderDrawer.instance.toggle();
                        },
                    },
                },
                {
                    widget: "dxSelectBox",
                    options: {
                        stylingMode: "text",
                        items: this.filiaisLogado,
                        displayExpr: "CAB_RAZAO",
                        keyExpr: "CAB_CODIGO",
                        width: 180,
                        value: this.filiaisLogado[1],
                        onValueChanged: (args) => {
                            if (args.value.CAB_CODIGO == 0) {
                                // Remove HTML para voltar ao estado inicial
                                $(".raster-app").empty();
                                setTimeout(() => {
                                    // Precisa de um tempinho pro JQuery conseguir remover tudo
                                    new selecionaEmpresa();
                                }, 10);
                            }
                        },
                    },
                },
                // {
                //     template: (e) => {
                //         const notificationBox = $('<div></div>').notificationCard({ notifications: [] });
                //         this.getUnreadNotifications().then((result) => {
                //             if ($('.card-notification-list')) {
                //                 result.data.forEach(message => {
                //                     $('<div></div>').notificationCard.update(message);
                //                 });
                //             }
                //         })
                //         socket.on("notification", (message) => {
                //             if ($('.card-notification-list')) {
                //                 $('<div></div>').notificationCard.update(message);
                //             }
                //         });

                //         return notificationBox;
                //     },
                // },
                {
                    widget: "dxDropDownButton",
                    location: "after",
                    options: {
                        text: (item) => {
                            return this.siglaUsuario;
                        },
                        elementAttr: { class: "menu-usuario" },
                        dropDownOptions: {
                            width: 230,
                        },
                        onItemClick: function (e) {
                            switch (e.itemData.name) {
                                case "Sair":
                                    new dxLoadPanel($(".loadpanel"), {
                                        shadingColor: "rgba(0,0,0,0.4)",
                                        position: {
                                            my: "center",
                                            at: "center",
                                        },
                                        showIndicator: true,
                                        showPane: true,
                                        shading: true,
                                        closeOnOutsideClick: false,
                                        message: "Desconectado...",
                                        visible: true,
                                    });

                                    logout();
                                    break;
                            }
                        },
                        displayExpr: "name",
                        keyExpr: "id",
                        items: [
                            {
                                name: `Olá, ${ControleSessao.getNomeUsuario()}`,
                                disabled: true,
                                template: () => {
                                    return $(
                                        `<div style='padding-bottom: 10px; border-bottom: 1px dashed #020039;'>Olá, ${ControleSessao.getNomeUsuario()}</div>`,
                                    );
                                },
                            },
                            {
                                name: "Sair",
                                icon: "fas fa-sign-out-alt",
                            },
                        ],
                    },
                },
            ],
        });
    }

    /**
     *
     * @param {{MNU_CODIGO: number, MNU_GRUPO: number, MNU_ORDEM: number, MNU_TITULO: string, TLA_CLASSEGRID: string, id: string}[]} mainArray
     */
    generateArrayMenu(mainArray) {
        this.menuLateral = [];
        let othis = this;

        let mainMenus = mainArray.filter((menu) => {
            return menu.MNU_GRUPO === 0;
        });

        for (const mainMenu of mainMenus) {
            this.IncluirItem(mainArray, mainMenu.MNU_CODIGO, othis);
        }

        $.each(mainArray, (index, value) => {
            // Filtra apenas os itens que pertencem ao menu "Jornada"
            if (
                value.MNU_SISTEMA == "JOR" ||
                (value.MNU_SISTEMA == "" &&
                    value.MNU_TITULO.includes("Jornada"))
            ) {
                if (value.TLA_CLASSEGRID == "") {
                    return;
                }

                let options = {};
                if (value.MNU_GRUPO !== 0) {
                    othis.IncluirItem(mainArray, value.MNU_GRUPO, othis);

                    options.categoria = value.MNU_GRUPO;
                    options.expanded = false;
                }

                othis.menuLateral.push({
                    ID: value.id,
                    name: "Tela" + index,
                    text: value.MNU_TITULO,
                    expanded: false,
                    classInvoke: value.TLA_CLASSEGRID,
                    ...options,
                });
            }
        });

        return this.menuLateral;
    }

    IncluirItem(lista, codigo, othis) {
        $.each(lista, (index, value) => {
            if (value.MNU_CODIGO == codigo) {
                let existeOpcao = $.grep(
                    othis.menuLateral,
                    function (vetor, index) {
                        return parseInt(vetor.ID) == codigo;
                    },
                );

                if (existeOpcao.length == 0) {
                    let options = {};
                    if (value.MNU_GRUPO !== 0) {
                        options.categoria = value.MNU_GRUPO;
                    }
                    othis.menuLateral.push({
                        ID: value.id,
                        name: "Tela" + index,
                        text: value.MNU_TITULO,
                        expanded: false,
                        classInvoke: value.TLA_CLASSEGRID,
                        ...options,
                    });
                }
                if (value.MNU_GRUPO !== 0) {
                    this.IncluirItem(lista, value.MNU_GRUPO, othis);
                }
            }
        });
    }

    autoHeight() {
        let alturaCabecalho = 46;
        if (window.innerWidth <= 450) {
            alturaCabecalho = 92;
        }
        this.renderControleTabPadrao.instance.option(
            "height",
            window.innerHeight - alturaCabecalho,
        );
        this.instanceTreeView.option(
            "height",
            window.innerHeight - alturaCabecalho,
        );

        window.addEventListener("resize", (evt) => {
            this.renderControleTabPadrao.instance.option(
                "height",
                window.innerHeight - alturaCabecalho,
            );
            this.instanceTreeView.option(
                "height",
                window.innerHeight - alturaCabecalho,
            );
        });
    }

    logout = () => {
        const refreshToken = ControleSessao.getRefreshToken();
        logout(refreshToken)
            .then(() => {
                location.reload();
            })
            .catch((err) => {
                console.log(err);
            });
    };
}
